import { api } from 'lib/axios'

export const validateToken = async accessToken => {
  const response = await api.post(
    '/Api/V8/custom/portal/validate-token',
    { access_token: accessToken },

  )
  return response.data
}
